import angular from 'angular';

angular
  .module('folder', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('folder', {
          data: {
            authorizedRole: 'USER_BO'
          }
        })
        .state('folder_details', {
          url: '/folder/{folderId:[0-9]+}',
          templateUrl: require('./folder-details.html'),
          controller: 'FolderDetailsCtrl',
          resolve: {
            folder: [
              '$transition$',
              'FolderService',
              function($transition$, FolderService) {
                return FolderService.get({ folderId: $transition$.params().folderId });
              }
            ]
          },
          data: {
            authorizedRole: 'USER_BO'
          }
        });
    }
  ]);
